import { get, values } from 'lodash'
import { createSelector } from 'reselect'

export const getPreOrders = state => values(get(state, 'order.byId'))

const getPreOrdersByEvent = (state, eventId) => {
  const preOrders = getPreOrders(state)
  const orders = preOrders.filter(preOrder => preOrder.salesEventId === eventId)

  return orders
}

export const makeGetPreOrdersByEvent = () => createSelector([getPreOrdersByEvent], (preOrders) => preOrders)

export const getIsPreOrdersLoading = state => state?.order?.isLoading ?? false
